export default __webpack_public_path__ + "static/media/YU_Pos_Preto.e2c4b80e.png";